module.exports = __webpack_public_path__ + "static/media/sexpirikos-book-cover.ad477fd7.jpg";